import { Charter } from "./charter";
import { cloneDeep } from "lodash";
import { ulid } from "ulid";
import dayjs from "../dayjs";
import { DATE_STRING } from "./schedule";

export const BOOKING_STATUS = [
    {label: 'Draft', value: 'new'},
    {label: 'Quote Sent', value: 'sent'},
    {label: 'Accepted', value: 'accepted'},
    {label: 'Scheduled', value: 'scheduled'},
    {label: 'Completed', value: 'completed'},
    {label: 'Cancelled', value: 'cancelled'},
]

export class Booking {
    constructor(props) {
        this.bookingId = '_';
        this.userId = '_';
        this.description = '';
        this.bookingReference = this.generateBookingReference();
        this.date = dayjs();
        this.numberOfPassengers = 1;
        this.status = 'new';
        this.charters = [];
        this.customer = null;
        this.charters = []; // Array of charter references
        this.quote = null;
        this.history = [];
        this.createdAt = new Date().toISOString();
        this.updatedAt = new Date().toISOString();

        Object.assign(this, props);

        if (this.charters?.length) {
            this.charters = this.charters.map(charter => new Charter(charter));
        }

        // Ensure date is always a dayjs object
        if (props?.date) {
            this.date = typeof props.date === 'string'
                ? dayjs(props.date, DATE_STRING)
                : dayjs(props.date);
        }
    }

    generateBookingReference() {
        // Format: BK-YYYYMMDD-XXXXX
        const date = dayjs().format('YYYYMMDD');
        const random = Math.floor(Math.random() * 100000).toString().padStart(5, '0');
        return `BK-${date}-${random}`;
    }

    addHistoryEntry(action, details) {
        this.history.push({
            timestamp: new Date().toISOString(),
            action,
            details,
            userId: this.userId
        });
        this.updatedAt = new Date().toISOString();
    }

    updateStatus(newStatus) {
        if (this.status !== newStatus) {
            const oldStatus = this.status;
            this.status = newStatus;
            this.addHistoryEntry('status_change', {
                from: oldStatus,
                to: newStatus
            });
        }
    }

    addCharter(charter) {
        this.charters.push({
            charterId: charter.charterId,
            name: charter.name,
            date: charter.date,
            status: charter.status
        });
        this.addHistoryEntry('charter_added', {
            charterId: charter.charterId,
            charterName: charter.name
        });
    }

    removeCharter(charterId) {
        const charter = this.charters.find(c => c.charterId === charterId);
        if (charter) {
            this.charters = this.charters.filter(c => c.charterId !== charterId);
            this.addHistoryEntry('charter_removed', {
                charterId,
                charterName: charter.name
            });
        }
    }

    isValid() {
        return true;
    }

    clone() {
        return new Booking(cloneDeep(this));
    }

    toJson() {
        const json = {
            ...this,
            date: this.date?.format(DATE_STRING),
            customer: this.customer || null,
        };
        return json;
    }

    fromJson() {
        if (this.date) {
            this.date = dayjs(this.date, DATE_STRING);
        }
        if (this.charters) {
            this.charters = this.charters.map(charter => ({
                ...charter,
                date: charter.date ? dayjs(charter.date, DATE_STRING) : null
            }));
        }
    }

    from(data) {
        return new Booking(data);
    }
}